import highlightjs from 'highlight.js/lib/core';
import json from 'highlight.js/lib/languages/json';
import diff from 'highlight.js/lib/languages/diff';
import markdown from 'highlight.js/lib/languages/markdown';

const highlightElement = element => {
  if (!highlightjs.listLanguages().includes('json')) {
    highlightjs.registerLanguage('json', json);
    highlightjs.registerLanguage('diff', diff);
    highlightjs.registerLanguage('markdown', markdown);
  }
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(() => highlightjs.highlightElement(element), {
      timeout: 500
    });
  } else {
    window.requestAnimationFrame(() => highlightjs.highlightElement(element));
  }
};

export { highlightElement };
